// The chat API sends newline-delimited snapshots, not token deltas.
export async function readChatStream(response, onMessage) {
  if (!response.ok) {
    const text = await response.text();
    let message = `请求失败（${response.status}），请重试`;
    try {
      const error = JSON.parse(text);
      message = error.msg || (error.error && error.error.message) || message;
    } catch (_) { /* Proxies may return an HTML error page. */ }
    throw new Error(message);
  }
  if (!response.body) throw new Error('未收到模型响应，请重试');
  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';
  let received = false;
  const consume = (line) => {
    if (!line.trim()) return;
    let data;
    try { data = JSON.parse(line); } catch (_) {
      throw new Error('模型响应不完整，请重试');
    }
    if (data.error || data.success === false) {
      throw new Error((data.error && data.error.message) || data.msg || '模型请求失败，请重试');
    }
    if (typeof data.content === 'string') {
      received = received || !!data.content.trim();
      onMessage(data);
    }
  };
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
      let boundary;
      while ((boundary = buffer.indexOf('\n')) >= 0) {
        consume(buffer.slice(0, boundary));
        buffer = buffer.slice(boundary + 1);
      }
      if (done) {
        consume(buffer);
        if (!received) throw new Error('模型未返回有效内容，请重试');
        break;
      }
    }
  } catch (error) {
    await reader.cancel().catch(() => {});
    throw error;
  } finally {
    reader.releaseLock();
  }
}

export function splitPolishResult(content) {
  // Accept existing Chinese/English headings and common Markdown punctuation.
  const polished = /(?:^|\n)\s*(?:#{1,6}\s*)?(?:1[.、)]\s*)?(?:\*\*)?(?:润色文本|Polished\s+text)\s*[:：](?:\*\*)?\s*/i;
  const notes = /(?:^|\n)\s*(?:#{1,6}\s*)?(?:2[.、)]\s*)?(?:\*\*)?(?:改写说明|Rewriting\s+(?:notes|explanation))\s*[:：](?:\*\*)?\s*/i;
  const textStart = polished.exec(content);
  const notesStart = notes.exec(content);
  if (!textStart || !notesStart || notesStart.index <= textStart.index) {
    return { text: content, notes: '' };
  }
  return {
    text: content.slice(textStart.index + textStart[0].length, notesStart.index).trim(),
    notes: content.slice(notesStart.index + notesStart[0].length).trim()
  };
}

export function selectChatModel(models, current, flag) {
  const available = (models || []).filter(item => item && item.model && item.status !== 0);
  return available.find(item => flag && item.flag === flag) ||
    available.find(item => current && item.model === current.model) || available[0] || current || {};
}
